import SourceFlowText from "@sourceflow-uk/sourceflowtext";
import {
  Container,
  Row,
  Col,
  Card,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Collapse,
} from "reactstrap";
import styles from "./styles.module.scss";
import Link from "next/link";
import SimpleForm from "../SimpleForm";
import React, { useState } from "react";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import HubSpotForm from "components/HubspotForm";

export default function GetInTouch({
  global,
  pathPrefix,
  customClass = "",
  content,
  content_2,
  content_3,
  buttonLink,
  buttonTitle,
  formId,
  hubspotForm,
  successPageUrl,
  post,
  direction,
  dropDownMenu = true,
  popUpModal_1 = false,
  popUpModal_1_form_id,
  dialog_content_1,
  hard_coded_contacts,
  showScriptubspotForm = false,
  ...args
}) {
  const [FormDropdownOpen, setFormDropdownOpen] = useState(false);
  const toggleFormDropdown = () =>
    setFormDropdownOpen((prevState) => !prevState);

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const [state, setState] = React.useState({});
  const { article } = state;

  React.useEffect(() => {
    setState((prevState) => ({
      moreInfoOpen: true,
    }));
    handleArticleOpen("0");
  }, []);

  const handleArticleOpen = (article) => {
    setState((prevState) => ({
      ...prevState,
      article,
    }));
  };

  const [formState, setformState] = React.useState({});
  const { form } = formState;

  React.useEffect(() => {
    setformState((prevState) => ({
      moreInfoOpen: true,
    }));
    handleFormOpen("1");
  }, []);

  const handleFormOpen = (form) => {
    setformState((prevState) => ({
      ...prevState,
      form,
    }));
  };

  React.useEffect(() => {
  if (!showScriptubspotForm) return;

  const script = document.createElement("script");
  script.src = "https://js-eu1.hsforms.net/forms/embed/v2.js";
  script.charset = "utf-8";
  script.type = "text/javascript";

  script.onload = () => {
    if (window.hbspt) {
      window.hbspt.forms.create({
        portalId: "26198844",
        formId: "0c72b8f4-2276-4b65-84b0-440ef4e5c398",
        region: "eu1",
        target: "#extra-hubspot-form",
      });
    }
  };

  document.body.appendChild(script);
}, [showScriptubspotForm]);


  const [selectedItem, setSelectedItem] = useState(post ? (post?.length > 1 ? "Select nearest office location" : post[0]?.title) : null);

  const [selectedFormItem, setSelectedFormItem] = useState("A Job Seeker");
  return (
    <section className={`${styles.root} ${customClass} py-1`}>
      <Container>
        <Row>
          <Col
            md={content_3 || formId || hubspotForm || showScriptubspotForm ? 6 : 12}
            className="pe-md-5 mb-5 mb-md-0"
          >
            {content ? (
              <div className="mb-4">
                <SourceFlowText
                  global={global}
                  path={`${pathPrefix}.content`}
                  type="html"
                >
                  {content}
                </SourceFlowText>
              </div>
            ) : null}
            {hard_coded_contacts ? (
              <div class="hotlines">{hard_coded_contacts}</div>
            ) : null}
            {post ? (
              <div className="rounded-4 primary-bg p-4 locations-wrapper mb-5">
                {post.length > 1 &&
                  <>
                    {/* Dropdown */}
                    <Dropdown
                    isOpen={dropdownOpen}
                    toggle={toggle}
                    direction={direction}
                    className="mb-4"
                    >
                      <DropdownToggle caret className="w-100 text-black">
                        {selectedItem || "Select nearest office location"}
                      </DropdownToggle>
                      <DropdownMenu {...args}>
                        {post.map((post, index) => (
                          <DropdownItem
                          key={index}
                          onClick={() => {
                            handleArticleOpen(`${index}`);
                            setSelectedItem(post.title); // Update selected location
                          }}
                          >
                            {post?.title}
                          </DropdownItem>
                        ))}
                      </DropdownMenu>
                    </Dropdown>
                  </>
                }

                {/* Details rendering */}
                {selectedItem !== "Select nearest office location" &&
                  post.map((post, index) => (
                    <Collapse isOpen={article === `${index}`} key={index}>
                      <div className="text-white">
                        <p className="m-0">
                          <strong>Visit Us</strong>
                        </p>
                        {post?.address && (
                          <div
                            className="post-address"
                            dangerouslySetInnerHTML={{ __html: post?.address }}
                          />
                        )}
                        {post?.google_map_link && (
                          <div className="mb-4">
                            <Link href={`${post?.google_map_link}`}>
                              <a
                                target="_blank"
                                rel="noopener noreferrer"
                                className="tertiaryBtn no-arrow"
                              >
                                Take me to Google Map
                              </a>
                            </Link>
                          </div>
                        )}
                        <p className="m-0">
                          <strong>Send Us An Email</strong>
                        </p>
                        <p>
                          <Link href={`mailto:${post?.email}`}>
                            <a>{post.email}</a>
                          </Link>
                        </p>
                        <p className="m-0">
                          <strong>Give Us A Ring</strong>
                        </p>
                        <p>
                          <Link href={`tel:${post?.telephone}`}>
                            <a>{post.telephone}</a>
                          </Link>
                        </p>
                      </div>
                    </Collapse>
                  ))}
              </div>
            ) : null}

            {content_2 ? (
              <>
                <hr></hr>
                <div className="mb-4 contentWrapper">
                  <SourceFlowText
                    global={global}
                    path={`${pathPrefix}.content_2`}
                    type="html"
                  >
                    {content_2}
                  </SourceFlowText>
                </div>
              </>
            ) : null}
            {popUpModal_1 ? (
              <button
                className="border-0 fancyBox primaryBtn no-arrow"
                data-src={`#dialog-content-1`}
              >
                {buttonTitle}
              </button>
            ) : buttonLink ? (
              <div>
                <Link href={`${buttonLink}`}>
                  <a className="tertiaryBtn no-arrow m-0">{buttonTitle}</a>
                </Link>
              </div>
            ) : null}
            {/* // {buttonLink ?
                            //     <div>
                            //         <Link href={`${buttonLink}`}>
                            //             <a className="tertiaryBtn no-arrow m-0">
                            //                 {buttonTitle}
                            //             </a>
                            //         </Link>
                            //     </div> : null} */}
            {popUpModal_1_form_id ? (
              <div class="dialog-content" id="dialog-content-1">
                <div>
                  {dialog_content_1 ? (
                    <>
                      <SourceFlowText
                        global={global}
                        path={`${pathPrefix}.dialog-content-1`}
                        type="html"
                      >
                        {dialog_content_1}
                      </SourceFlowText>{" "}
                      <hr></hr>
                    </>
                  ) : null}

                  <SimpleForm
                    formId={`${popUpModal_1_form_id}`}
                    successPageUrl={`${successPageUrl}`}
                  />
                </div>
              </div>
            ) : null}
          </Col>
          <Col md={6}>
            {content_3 ? (
              <>
                <div className="mb-4">
                  <SourceFlowText
                    global={global}
                    path={`${pathPrefix}.content_3`}
                    type="html"
                  >
                    {content_3}
                  </SourceFlowText>
                </div>
              </>
            ) : null}
            {formId ? (
              <SimpleForm
                formId={`${formId}`}
                successPageUrl={`${successPageUrl}`}
                customClass={`secondary-bg p-4 p-md-5 rounded-4`}
              />
            ) : null}

            {hubspotForm ? <HubSpotForm form_id={hubspotForm} /> : null}

            {showScriptubspotForm && (
              <div id="extra-hubspot-form" className="mt-4" />
            )}
            {/* {dropDownMenu ?  <div className="rounded-4 primary-bg p-4 locations-wrapper mb-5">
              <p className="text-white">
                Select who you are from the dropdown menu
              </p>
              <Dropdown
                isOpen={FormDropdownOpen}
                toggle={toggleFormDropdown}
                direction={direction}
              >
                <DropdownToggle caret className="w-100 text-black">
                  {selectedFormItem}
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem
                    onClick={() => {
                      handleFormOpen("1");
                      setSelectedFormItem("A job seeker");
                    }}
                    className={`${form === "1" ? "active" : ""}`}
                  >
                    A job seeker
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => {
                      handleFormOpen("2");
                      setSelectedFormItem("Looking to Hire");
                    }}
                    className={`${form === "2" ? "active" : ""}`}
                  >
                    Looking to Hire
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
              <div className="mt-5">
                <Collapse isOpen={form === "1"}>
                  <SimpleForm
                    formId={"301d0658-8037-4a75-9746-ddd447332df5"}
                    successPageUrl={successPageUrl}
                    customClass={`bg-white p-4 p-md-5 rounded-4`}
                  />
                </Collapse>
                <Collapse isOpen={form === "2"}>
                  <SimpleForm
                    formId={"e948a7bd-9d41-4be7-b06e-5895ab557faf"}
                    successPageUrl={successPageUrl}
                    customClass={`bg-white p-4 p-md-5 rounded-4`}
                  />
                </Collapse>
              </div>
            </div> : <></>} */}
            {/* {post?.sourceflow_form_embed_api ?
                                    <SimpleForm
                                        formId={`${post?.sourceflow_form_embed_api}`}
                                        successPageUrl={successPageUrl}
                                        customClass={`bg-white p-4 p-md-5 rounded-4`}
                                    /> : null
                                }  */}
          </Col>
        </Row>
      </Container>
    </section>
  );
}
